module.exports = __webpack_public_path__ + "img/align-vertical-top.aff20b47.svg";